module.exports = __webpack_public_path__ + "static/obergeschoss-f6f9ebe8313d6ff6e8d2970b06660fad.png";